import { CloseButton, Dialog, Portal } from '@chakra-ui/react'

import ContactUs from './ContactUs'

type ContactModalProps = {
  isOpen: boolean
  onClose: () => void
}

const ContactModal = ({ isOpen, onClose }: ContactModalProps) => {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={({ open }) => {
        if (!open) onClose()
      }}
      scrollBehavior='inside'
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title color='darkBlue'>Sign Up</Dialog.Title>
            </Dialog.Header>
            <Dialog.Description px='6' pb='4'>
              Ready to take advantage of the Worldesk platform. Give us your
              information and we’ll be in touch about our onboarding process!
            </Dialog.Description>
            <Dialog.Body>
              <ContactUs asModal />
            </Dialog.Body>
            <Dialog.CloseTrigger asChild>
              <CloseButton size='sm' />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}

export default ContactModal
